export const JobsKey = 'jobs-69lgk' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
